import type { ITagRepository } from "~/interfaces/ITagRepository";
import { TagsResponse } from "~/entities/TagsResponse";
import type { UserTagTypeResponse } from "~/entities/UserTagTypeResponse";

export class TagRepository implements ITagRepository {
  /**
   * tag一覧を取得する
   */
  async fetch(): Promise<TagsResponse> {
    const tags = await GetRequest<TagsResponse>("/tags");
    return tags;
  }

  /**
   * user tag type一覧を取得する
   */
  async fetchUserTagTypes(options: Record<string, string>): Promise<UserTagTypeResponse> {
    const paramsObj: { [name: string]: string } = {
      ...filterEmptyObject(options || {}),
    };
    const searchParams = new URLSearchParams(paramsObj);
    const tags = await GetRequest<UserTagTypeResponse>(`/user_tag/type?${searchParams.toString()}`);
    return tags;
  }
}
